import { render, staticRenderFns } from "./AgreementList.vue?vue&type=template&id=27dedbe5&scoped=true"
import script from "./AgreementList.vue?vue&type=script&lang=js"
export * from "./AgreementList.vue?vue&type=script&lang=js"
import style0 from "./AgreementList.vue?vue&type=style&index=0&id=27dedbe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dedbe5",
  null
  
)

export default component.exports